import { Box, useTheme } from "@mui/material";

type BrandMarkVariant = "icon" | "wordmark";

type BrandMarkProps = {
  variant?: BrandMarkVariant;
  height?: number;
  /** Force a specific theme variant — otherwise auto from current theme. */
  forceTheme?: "light" | "dark";
};

/**
 * CORTEX Planning brand mark.
 *
 * Renders the official SVG from /public/brand/. Picks the variant matching
 * the current theme automatically (or honors `forceTheme`).
 *
 * Usage:
 *   <BrandMark variant="icon" height={32} />
 *   <BrandMark variant="wordmark" height={40} />
 */
export function BrandMark({ variant = "wordmark", height = 32, forceTheme }: BrandMarkProps) {
  const theme = useTheme();
  const themeMode = forceTheme ?? theme.palette.mode;

  if (variant === "icon") {
    return (
      <Box
        component="img"
        src="/brand/icon.svg"
        alt="CORTEX Planning"
        sx={{ height, width: height, display: "block" }}
      />
    );
  }

  const src = themeMode === "dark" ? "/brand/wordmark-dark.svg" : "/brand/wordmark-light.svg";
  return (
    <Box
      component="img"
      src={src}
      alt="CORTEX Planning"
      sx={{ height, width: "auto", display: "block" }}
    />
  );
}
